import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Grid from '../../../components/Grid/Grid';
import Button from '../../../components/Button/Button';
import ControlledFormingElNoCreateDialog from './ControlledFormingElNoCreateDialog';

const ControlledFormingElNoTableToolbar = ({ onAddControlledFormingElNoSuccess }) => {
  const [isAddingControlledFormingElNoOpen, setIsAddingControlledFormingElNoOpen] = useState(false);

  const handleAddingControlledFormingElNoOpen = (e) => {
    e.preventDefault();
    setIsAddingControlledFormingElNoOpen(true);
  };

  return (
    <div>
      <div>
        <Toolbar>
          <Grid
            container
            style={{ marginTop: 25, marginBottom: 20, width: '100%' }}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid xs={6}>
              <Button
                variant="outlined"
                color="primary"
                rounded
                startIcon={<AddIcon />}
                onClick={handleAddingControlledFormingElNoOpen}
              >
                新增管制規格
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </div>
      <ControlledFormingElNoCreateDialog
        isOpen={isAddingControlledFormingElNoOpen}
        onClose={() => setIsAddingControlledFormingElNoOpen(false)}
        onSubmitSuccess={onAddControlledFormingElNoSuccess}
      />
    </div>
  );
}; // TransferDetectTypeTableToolbar

ControlledFormingElNoTableToolbar.propTypes = {
  onAddControlledFormingElNoSuccess: PropTypes.func.isRequired,
};

export default ControlledFormingElNoTableToolbar;
